import React, { forwardRef } from 'react';

import Grid from 'components/designSystem/Grid/Grid.tsx';
import Image from 'next/legacy/image';

import AppLinks from './AppLinks/AppLinks';
import QRCode from './QRCode/QRCode';

import styles from './Acquisition.module.scss';
import sourceImage from './Img-App.jpg';

function Acquisition(props, ref) {
  return (
    <section ref={ref} className={styles.acquisition}>
      <Grid container className={styles.acquisitionWrap}>
        <Grid sm={4} md={6} lg={6} className={styles.imgWrap}>
          <Image
            src={sourceImage}
            className={styles.image}
            alt="ChowNow App"
            height={636}
            width={636}
            layout="responsive"
            placeholder="blur"
          />
        </Grid>
        <Grid sm={4} md={6} lg={6} className={styles.copyWrap}>
          <div className={styles.copyWrapper}>
            <p className={styles.body}>Food delivery and pickup in a few taps.</p>
            <div className={styles.mobileButton}>
              <AppLinks />
            </div>
            <div className={styles.desktopQR}>
              <QRCode />
            </div>
          </div>
        </Grid>
      </Grid>
    </section>
  );
}

export default forwardRef(Acquisition);
